import dynamic from "next/dynamic";
const HubspotOnDarkBackgroundFormComponent = dynamic(()=>import("./hubspot-on-dark-background-form-component"));
import HubspotOnDarkBackgroundFormConfig from "./hubspot-on-dark-background-form-config";
import HubspotOnDarkBackgroundFormAdvancedConfig from "./hubspot-on-dark-background-form-advanced-config";
export default {
    HubspotOnDarkBackgroundFormComponent,
    HubspotOnDarkBackgroundFormConfig,
    HubspotOnDarkBackgroundFormAdvancedConfig
};
